<div class="text-center">
    <div  [ngClass]="(IsPageFrm === 'prevoiusRefills') ? 'eprx--block__footer mt-3': (IsPageFrm === 'TransferOut' ? 'eprx--block__footer_transfer' : 'eprx--block__footer')">
        <span></span>
        <i class="fa fa-file"></i><br/>
           {{TextDisplay}}
    </div>
</div>